import React, { useEffect, useState } from 'react';

const LanguageSelector = () => {
  const [selectedLang, setSelectedLang] = useState('en');

  useEffect(() => {
    // Check karo agar pehle se koi language set hai
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };
    
    const currentCookie = getCookie('googtrans');
    if (currentCookie) {
        // Cookie se language code nikalo (e.g., '/en/hi' -> 'hi')
        const lang = currentCookie.split('/')[2]; 
        setSelectedLang(lang);
    }
  }, []);

  const handleLanguageChange = (e) => {
    const langCode = e.target.value;
    setSelectedLang(langCode);

    // Google Translate Cookie Set karo
    document.cookie = `googtrans=/auto/${langCode}; path=/; domain=${window.location.hostname}`;
    document.cookie = `googtrans=/auto/${langCode}; path=/;`; // Backup

    // Page Reload taaki translation apply ho jaye
    window.location.reload();
  };

  return (
    <div className="relative">
      <select
        value={selectedLang}
        onChange={handleLanguageChange}
        className="appearance-none bg-white border border-slate-300 text-slate-900 font-bold text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-8 cursor-pointer shadow-sm"
      >
        <option value="en">🇬🇧 English</option>
        <option value="hi">🇮🇳 Hindi (हिंदी)</option>
        <option value="ml">🌴 Malayalam (മലയാളം)</option>
        <option value="bn">🐯 Bengali (বাংলা)</option>
        <option value="te">🌶️ Telugu (తెలుగు)</option>
        <option value="ta">🛕 Tamil (தமிழ்)</option>
        <option value="mr">🚩 Marathi (मराठी)</option>
        <option value="gu">🦁 Gujarati (ગુજરાતી)</option>
        <option value="kn">💻 Kannada (ಕನ್ನಡ)</option>
        <option value="pa">👳 Punjabi (ਪੰਜਾਬੀ)</option>
      </select>
    </div>
  );
};

export default LanguageSelector;